import React from 'react';

const Page404 = () => (
    <div style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f8fafc',
        color: '#222',
        fontFamily: 'Segoe UI, Arial, sans-serif'
    }}>
        <h1 style={{ fontSize: '6rem', margin: 0, fontWeight: 700, color: '#2563eb' }}>404</h1>
        <h2 style={{ fontSize: '2rem', margin: '1rem 0 0.5rem 0' }}>Page Not Found</h2>
        <p style={{ fontSize: '1.1rem', marginBottom: '2rem', color: '#555' }}>
            Sorry, the page you are looking for does not exist or has been moved.
        </p>
        <a
            href="/"
            style={{
                padding: '0.75rem 1.5rem',
                background: '#2563eb',
                color: '#fff',
                borderRadius: '0.5rem',
                textDecoration: 'none',
                fontWeight: 500,
                boxShadow: '0 2px 8px rgba(37,99,235,0.1)'
            }}
        >
            Go Home
        </a>
    </div>
);

export default Page404;